<button
  *ngIf="enabled"
  type="button"
  class="env-switcher"
  [title]="'Go to ' + targetPath + '  (Ctrl/Cmd + Shift + A)'"
  (click)="switch()">
  <span class="env-switcher__dot"></span>
  {{ targetLabel }}
</button>
